import { Typography } from "antd";


const { Title } = Typography;

function ErrorMessage() {
  return (
    <div id="loading-icon">
      <Title>Error... please try again later</Title>
    </div>
  );
}

export default ErrorMessage;
